import { AxiosResponse, AxiosError } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import { TNinusiHokokusyoPrintYamadaReq } from "./TNinusiHokokusyo"

/**
 * 荷主報告書画面に対するAPIリクエスト用サービス
 *
 * @export
 * @class MenuService
 * @extends {ConnectApi}
 */
export default class NinusiHokokusyoService extends ConnectApi {
  /**
   * 山田産業報告書印刷
   *
   * @param {TNinusiHokokusyoPrintYamadaReq} params
   * @memberof ninusiHokokusyoService
   */
  printHokokusyoYamada = async (
    params: TNinusiHokokusyoPrintYamadaReq,
    resolve?: (param: TApiResponse<Blob>) => any,
    reject?: (param: AxiosError<TApiResponse<Blob>>) => any
  ) => {
    try {
      //API呼出
      const res: AxiosResponse<Blob> = await this.postInner(
        `/report/CreateReport/G060402`,
        params
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
